import "core-js/modules/es.object.to-string.js";
export function getCommonValues(key, items) {
  if (!items || items.length === 0) {
    return undefined;
  }
  var firstValue = items[0][key];
  var isSameValue = items.every(function (item) {
    return item[key] === firstValue;
  });
  return isSameValue ? firstValue : undefined;
}